import { Email } from "@styled-icons/material/Email"
import { OldPhone } from "@styled-icons/entypo/OldPhone"
import { Whatsapp } from "@styled-icons/icomoon/Whatsapp"
import { LocationOn } from "@styled-icons/material/LocationOn"
import { Motorcycle } from "@styled-icons/fa-solid/Motorcycle"
import { CreditCard } from "@styled-icons/fa-solid/CreditCard"
import { ShutterSpeed } from "@styled-icons/material/ShutterSpeed"
import { Hearts } from "@styled-icons/remix-fill/Hearts"
import { Award } from "@styled-icons/fa-solid/Award"
import { Home } from "@styled-icons/boxicons-solid/Home"
import { LibraryBooks } from "@styled-icons/material/LibraryBooks"
import { HomeRepairService } from "@styled-icons/material-sharp/HomeRepairService"

const Icons = {
  Email,
  OldPhone,
  Whatsapp,
  Motorcycle,
  CreditCard,
  ShutterSpeed,
  Hearts,
  Award,
  LocationOn,
  Home,
  LibraryBooks,
  HomeRepairService,
}

export default Icons
